module.exports = __webpack_public_path__ + "img/cert-laason.948268fe.jpg";